export var DevPlanMethod;
(function (DevPlanMethod) {
    DevPlanMethod["Monthly"] = "month";
    DevPlanMethod["Annually"] = "year";
})(DevPlanMethod || (DevPlanMethod = {}));
